import { Fragment } from "react";

const ConfidenceBadge = ({ confidence }) => {
  const value = (confidence || "medium").toLowerCase();
  const classMap = {
    high: "badge--success",
    medium: "badge--warning",
    low: "badge--info",
  };
  const label = value.charAt(0).toUpperCase() + value.slice(1);
  return <span className={`badge ${classMap[value] || classMap.medium}`}>{label}</span>;
};

const WatermarkTable = ({ watermarks }) => {
  if (!watermarks || watermarks.length === 0) {
    return (
      <div className="watermark-decoder__no-results">
        <h4>No Watermark Detected</h4>
        <p>No watermark found in the image. You can use the manual input form below.</p>
      </div>
    );
  }

  return (
    <table className="watermark-decoder__table">
      <thead>
        <tr>
          <th>#</th>
          <th>Username</th>
          <th>Hostname</th>
          <th>Epoch</th>
          <th>Method</th>
          <th>Confidence</th>
          <th>Raw Text</th>
        </tr>
      </thead>
      <tbody>
        {watermarks.map((wm, index) => (
          <Fragment key={index}>
            <tr>
              <td>
                <strong>{index + 1}</strong>
              </td>
              <td>{wm.username || "N/A"}</td>
              <td>{wm.hostname || "N/A"}</td>
              <td>{wm.epoch ? wm.epoch.toString() : "N/A"}</td>
              <td>{wm.session_method || "N/A"}</td>
              <td>
                <ConfidenceBadge confidence={wm.confidence} />
              </td>
              <td>
                <code>{wm.raw_text || ""}</code>
              </td>
            </tr>
            {wm.decrypted && (
              <tr className="watermark-decoder__table__decrypted-row">
                <td colSpan={7}>
                  <strong className="watermark-decoder__table__decrypted-title">
                    🔓 Decrypted Data:
                  </strong>
                  <div className="watermark-decoder__table__decrypted-grid">
                    <div>
                      <strong>Username:</strong> {wm.decrypted.username || "N/A"}
                    </div>
                    <div>
                      <strong>Computer:</strong> {wm.decrypted.computername || "N/A"}
                    </div>
                    <div>
                      <strong>Epoch Hour:</strong> {wm.decrypted.epochhour || "N/A"}
                    </div>
                    <div>
                      <strong>Readable Time:</strong>{" "}
                      <span className="watermark-decoder__table__highlight">
                        {wm.decrypted.timestamp || "N/A"}
                      </span>
                    </div>
                    <div>
                      <strong>Login Method:</strong> {wm.decrypted.loginmethod || "N/A"}
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default WatermarkTable;
